/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findRecentOrderStatus = (queryName = 'recentOrderStatus') => (
    gql`query ${queryName} (
        $brand: String!
        $environment: String!
        $user: UserSF!
        $daysInPast: Int!
        $daysInFuture: Int!
    ) {
        recentOrderStatus(
            brand: $brand
            environment: $environment
            user: $user
            daysInPast: $daysInPast
            daysInFuture: $daysInFuture
        ) {
            recentOrders {
                orderNumber
                recpFirstName
                recpLastName
                businessName
                estimatedDeliveryDate
                delivered
                productImageURL
                status
            }
        }
    }`
);

export default findRecentOrderStatus;
